import { FC, useId } from 'react';
import { useTranslation } from 'react-i18next';
import { TooltipGroup } from '@/components/shared/tooltip/TooltipGroup';
import Text from '@/storybook/components/Text/Text';
import AILogoGradientIcon from '@/storybook/icons/AILogoGradientIcon';
import BetaBadge from '../BetaBadge/BetaBadge';
import { TestIds } from './testIds';
import styles from './ChatEmptyState.module.css';

export interface ChatEmptyStateProps {
  userName?: string;
}

const ChatEmptyState: FC<ChatEmptyStateProps> = ({ userName }) => {
  const { t } = useTranslation();
  const tooltipGroupId = useId();

  const title = userName
    ? t('components.aiChatDrawer.emptyState.titleWithName', { name: userName })
    : t('components.aiChatDrawer.emptyState.title');

  return (
    <TooltipGroup
      id={`ai-chat-empty-${tooltipGroupId}`}
      shouldShowForTruncatedOnly={false}
      delayShow={200}
      rootClassName={styles.tooltipGroup}
      childrenWrapperClassName={styles.tooltipChildrenWrapper}
    >
      <div className={styles.container} data-testid={TestIds.container}>
        <div className={styles.avatar} data-testid={TestIds.avatar}>
          <AILogoGradientIcon className={styles.avatarIcon} />
        </div>

        <div className={styles.textGroup}>
          <div className={styles.subtitleRow}>
            <Text as="span" className={styles.subtitle}>
              {t('components.aiChatDrawer.emptyState.subtitle')}
            </Text>
            <BetaBadge data-testid={TestIds.betaBadge} />
          </div>

          <Text as="h2" className={styles.title} data-testid={TestIds.title}>
            {title}
          </Text>
        </div>
      </div>
    </TooltipGroup>
  );
};

export default ChatEmptyState;
